import React, { useEffect, useState } from "react";
import styled from "styled-components";

const TidalTagWrapper = styled.div`
  height: 26px;
  padding: 0 12px;
  border-radius: 74px;
  width: max-content;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const TidalSuccessTagWrapper = styled(TidalTagWrapper)<{
  enabled: boolean;
}>`
  background-color: ${(props) =>
    props.enabled
      ? props.theme.colors.tags[0]
      : `${props.theme.colors.tags[0]}3d`};
  color: ${(props) => (props.enabled ? "#fff" : props.theme.colors.tags[0])};
`;

const TidalPrimaryTagWrapper = styled(TidalTagWrapper)<{
  enabled: boolean;
}>`
  background-color: ${(props) =>
    props.enabled
      ? props.theme.colors.tags[1]
      : `${props.theme.colors.tags[1]}3d`};
  color: ${(props) => (props.enabled ? "#fff" : props.theme.colors.tags[1])};
`;

const TidalWarningTagWrapper = styled(TidalTagWrapper)<{
  enabled: boolean;
}>`
  background-color: ${(props) =>
    props.enabled
      ? props.theme.colors.tags[2]
      : `${props.theme.colors.tags[2]}3d`};
  color: ${(props) => (props.enabled ? "#fff" : props.theme.colors.tags[2])};
`;

const TidalInfoTagWrapper = styled(TidalTagWrapper)<{
  enabled: boolean;
}>`
  background-color: ${(props) =>
    props.enabled
      ? props.theme.colors.tags[3]
      : `${props.theme.colors.tags[3]}3d`};
  color: ${(props) => (props.enabled ? "#fff" : props.theme.colors.tags[3])};
`;

const TidalErrorTagWrapper = styled(TidalTagWrapper)<{
  enabled: boolean;
}>`
  background-color: ${(props) =>
    props.enabled
      ? props.theme.colors.tags[4]
      : `${props.theme.colors.tags[4]}3d`};
  color: ${(props) => (props.enabled ? "#fff" : props.theme.colors.tags[4])};
`;

const TidalColorTagWrapper = styled(TidalTagWrapper)<{ color: string }>`
  background-color: ${(props) => `rgb(${props.color})`};
  color: #fff;
`;

interface ITidalTag {
  type?: string | number;
  title: string;
  color?: string;
  enabled?: boolean;
}

const TidalTag = ({ type, title, enabled, color }: ITidalTag): JSX.Element => {
  if (type == "success")
    return (
      <TidalSuccessTagWrapper enabled={enabled}>{title}</TidalSuccessTagWrapper>
    );
  if (type == "primary")
    return (
      <TidalPrimaryTagWrapper enabled={enabled}>{title}</TidalPrimaryTagWrapper>
    );
  if (type == "warning")
    return (
      <TidalWarningTagWrapper enabled={enabled}>{title}</TidalWarningTagWrapper>
    );
  if (type == "info")
    return <TidalInfoTagWrapper enabled={enabled}>{title}</TidalInfoTagWrapper>;
  if (type == "error")
    return (
      <TidalErrorTagWrapper enabled={enabled}>{title}</TidalErrorTagWrapper>
    );
  if (color)
    return <TidalColorTagWrapper color={color}>{title}</TidalColorTagWrapper>;
};

export default TidalTag;
